import { Checkbox } from '../../../common/components';
import { getPrice } from '../../../common/routines/utils';

const BulkStatementTableRow = ({
  rowData,
  index,
  checked,
  rowCheckChanged,
  onPurchaserOpiClick,
  slNo,
}) => {
  const {
    onePortalId,
    purchaserName,
    adjustment,
    bills,
    balanceDue,
    payment,
    // contractNumber
  } = rowData;

  const onOpiClick = () => {
    onPurchaserOpiClick(rowData, index);
  };

  const onCheckChanged = (event) => {
    rowCheckChanged(event, bills, onePortalId);
  };
  return (
    <tr className="table-body-tr">
      <td className="checkbox-table">
        <Checkbox
          simple
          label=""
          onChange={onCheckChanged}
          checked={checked}
          name={`${onePortalId}_${index}`}
        />
      </td>
      <td>{slNo}</td>
      <td onClick={onOpiClick} className="cursor-pointer">
        {onePortalId || '-'}
      </td>
      <td>{purchaserName || '-'}</td>
      <td>{getPrice(bills) || '-'}</td>
      <td>{getPrice(payment) || '-'}</td>
      <td>{getPrice(adjustment) || '-'}</td>
      <td>{getPrice(balanceDue) || '-'}</td>
    </tr>
  );
};

export default BulkStatementTableRow;
